module.exports = __webpack_public_path__ + "media/src/fonts/uni-neue/uni-neue-400-regular-725effd3e7a57d67bd7de40a39601481.woff2";